import * as React from 'react';

const s = require('./search_filters.css');

interface IProps {
  title: string;
  onSubmit(): void;
  onMapSubmit(): void;
}

export class SearchFilters extends React.Component<IProps> {
  public render() {

    return (
      <div className={s['c-filters-inner']}>
        <div className={s['c-filters-title']}>
          <span className={s['c-filters-title-text']}>{this.props.title}</span>
        </div>
        <div className={s['c-filters-form']}>
          { this.props.children }
        </div>
        <div className={s['c-filters-form-buttons']}>
          <button className={s['c-filters-field-button']} onClick={() => this.props.onSubmit()}>Найти</button>
          <a
              role="button"
              className={`${s['c-filters-field-map-button']}`}
              onClick={() => this.props.onMapSubmit()}><span>Показать на карте</span>
          </a>
        </div>
      </div>
    );
  }
}
